import React, { useState } from 'react';
import { Close } from '@mui/icons-material';
import './SiteNotice.css';

const STORAGE_KEY = 'dofgen:siteNoticeDismissed';
const TXT_DISMISS = { fr: 'Fermer', en: 'Dismiss', de: 'Schließen', es: 'Cerrar', pt: 'Fechar' };

/**
 * An operator notice across the top of every page, set without a rebuild:
 * `fly secrets set SITE_NOTICE='{"fr":"…","en":"…"}' -a dofusbuilder-frontend`
 * (or a plain string), and `fly secrets unset SITE_NOTICE` to take it down.
 * server.js hands it over in __RUNTIME_CONFIG__. Dismissing hides that exact
 * text for the session; a new text shows again.
 */
function readNotice(lang) {
    const raw = typeof window !== 'undefined' ? window.__RUNTIME_CONFIG__?.SITE_NOTICE : null;
    if (!raw) return '';
    if (typeof raw === 'string') return raw;
    return raw[lang] || raw.en || raw.fr || '';
}

function wasDismissed(text) {
    try {
        return sessionStorage.getItem(STORAGE_KEY) === text;
    } catch (_err) {
        return false;
    }
}

const SiteNotice = ({ lang }) => {
    const text = readNotice(lang);
    const [dismissed, setDismissed] = useState(() => wasDismissed(text));
    if (!text || dismissed) return null;

    const dismiss = () => {
        try {
            sessionStorage.setItem(STORAGE_KEY, text);
        } catch (_err) {
            // Private mode: it just comes back on the next page load.
        }
        setDismissed(true);
    };

    return (
        <div className="site-notice row" role="status">
            <span className="site-notice-text">{text}</span>
            <button
                type="button"
                className="site-notice-close"
                onClick={dismiss}
                aria-label={TXT_DISMISS[lang] || TXT_DISMISS.en}
            >
                <Close sx={{ fontSize: '1rem' }} />
            </button>
        </div>
    );
};

export default SiteNotice;
